export default __webpack_public_path__ + "public/images/services/Shield@2x.png?09410f91";